import React from 'react';
import { Card, Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { LatestStatementWrapper } from './latest-statement-explainer.style';

const getCopy = copyFor('billing.emptyState.latestStatement');

export const LatestStatementExplainer = () => {
  return (
    <Card mobileVariant="flat">
      <Card.Header>
        <Text
          tag="h2"
          margin={{ top: '0', bottom: '16px' }}
          textStyle="heading700"
        >
          {getCopy('title')}
        </Text>
      </Card.Header>
      <Card.Content>
        <LatestStatementWrapper flex direction="column" alignItems="center">
          <Icon
            icon="DollarCircle"
            opacity="low"
            scale={3}
            margin={{ bottom: '18px', top: '34px' }}
          />
          <Text margin={{ bottom: '32px', left: '48px', right: '48px' }}>
            {getCopy('description')}
          </Text>
        </LatestStatementWrapper>
      </Card.Content>
    </Card>
  );
};
